import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceCompanyClient } from '../../models/invoices';

@Component({
  selector: 'app-client-card',
  standalone: false,
  templateUrl: './client-card.component.html',
  styleUrl: './client-card.component.scss',
})
export class ClientCardComponent {
  @Input()
  client!: InvoiceCompanyClient;
}
